<div class="bg-white p-4">
    <div class="overflow-x-auto">

        <div class="flex flex-wrap items-center space-x-2 overflow-x-auto pb-4 bg-white w-full px-0">
            <div class="flex flex-nowrap items-center space-x-2 flex-grow">
                <!-- <select id="department" [ngModel]="departmentId()"
                    class="px-3 py-2 rounded-lg bg-white/10 border border-gray-300 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
                    (ngModelChange)="onDepartmentChange($event)">
                    @for (dept of $$departmentDTO(); track dept.departmentId) {
                    <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
                    }
                </select> -->
                <div class="relative sm:w-auto">
                    <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg class="w-4 h-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>

                    <input type="search" [(ngModel)]="searchParams().pp_number"
                        class="focus:ring-gray-100 focus:border-gray-300 p-2.5 block w-full pl-10 pr-3 py-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                        placeholder="PP Number" (search)="fetchOperationData()">
                </div>

                <div class="relative">
                    <select [(ngModel)]="searchParams().status"
                        class="focus:ring-gray-100 focus:border-gray-300 py-2 block w-full text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50">
                        <option value="">All Status</option>
                        <option *ngFor="let status of jobStatuses" [value]="status">{{ status | titlecase }}</option>
                    </select>
                </div>

                <div class="flex-shrink-0">
                    <button (click)="fetchOperationData()" type="submit"
                        class="button-blue inline-flex items-center whitespace-nowrap">
                        <span class="hidden sm:inline">Search</span>
                    </button>
                </div>
            </div>

            <div class="ml-auto flex-shrink-0">
                <button type="button" class="button-blue inline-flex items-center whitespace-nowrap"
                    (click)="openDownloadReport()">
                    Download Delivery Plan
                </button>
            </div>
        </div>

        <hr class="border-t border-gray-200 mb-4 mt-1" />

        <div class="table-wrapper overflow-x-auto">
            <table class="table">
                <thead class="table-thead">
                    <tr>
                        <th scope="col" class="px-6 py-3">Job No</th>
                        <th scope="col" class="px-6 py-3">Job Name</th>
                        <th scope="col" class="px-6 py-3">Customer</th>
                        <th scope="col" class="px-6 py-3">Quantity</th>
                        <th scope="col" class="px-6 py-3">Job Status</th>
                        <th scope="col" class="px-6 py-3">Customer Request Date</th>
                        <th scope="col" class="px-6 py-3">Delivery Date</th>
                        <th scope="col" class="px-6 py-3">Dispatch Quantity</th>
                        <th style="width: 40%;" scope="col" class="px-6 py-3">Machine Sequence</th>
                        <th scope="col" class="px-6 py-3">Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for (jobs of $$jobDTOS(); track jobs) {
                    <tr class="bg-white border-b">
                        <td class="px-4 py-2 text-sm">{{ jobs.jobNo| uppercase }}
                        <td class="px-4 py-2 text-sm">{{ jobs.jobDescription }}
                        <td class="px-6 py-2 text-sm">{{ jobs.customer || '-' | uppercase }}
                        <td class="px-4 py-2 text-sm"><span>{{ jobs.jobQuantity | number}}</span>
                        <td class="px-4 py-2 text-sm"><app-status-badge [jobStatus]="jobs.jobStatus"></app-status-badge>
                        </td>
                        <td class="px-4 py-2 text-sm"><span>{{ jobs.requestDate }}</span></td>
                        <td class="px-4 py-2 text-sm">
                            @if (editingDeliveryDateForJobId() === jobs.jobId) {
                            <div class="flex items-center gap-1">
                                <input type="date" [ngModel]="tempDeliveryDate()"
                                    (ngModelChange)="tempDeliveryDate.set($event)" [min]="minDate"
                                    class="text-xs p-1 border rounded w-32 focus:ring-blue-500 focus:border-blue-500" />
                                <button (click)="saveDeliveryDate(jobs.jobId)" [disabled]="isUpdatingDeliveryDate()"
                                    class="p-1 text-emerald-600 hover:bg-emerald-50 rounded disabled:opacity-50"
                                    title="Save">
                                    <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </button>
                                <button (click)="cancelEditingDeliveryDate()" [disabled]="isUpdatingDeliveryDate()"
                                    class="p-1 text-red-600 hover:bg-red-50 rounded disabled:opacity-50" title="Cancel">
                                    <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12">
                                        </path>
                                    </svg>
                                </button>
                            </div>
                            } @else {
                            @if (showOperationChange()) {
                            <div class="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-1 -ml-1 rounded group w-max"
                                (click)="startEditingDeliveryDate(jobs)" title="Click to edit delivery date">
                                @if (jobs.finalizedDeliveryDate) {
                                <div class="flex flex-col">
                                    <span class="line-through text-gray-400 text-[11px] leading-tight">{{
                                        jobs.deliveryDate }}</span>
                                    <span class="text-emerald-600 font-medium">{{ jobs.finalizedDeliveryDate }}</span>
                                </div>
                                } @else {
                                <span>{{ jobs.deliveryDate }}</span>
                                }
                                <svg class="w-3.5 h-3.5 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                                    </path>
                                </svg>
                            </div>
                            } @else {
                            @if (jobs.finalizedDeliveryDate) {
                            <div class="flex flex-col">
                                <span class="line-through text-gray-400 text-[11px] leading-tight">{{ jobs.deliveryDate
                                    }}</span>
                                <span class="text-emerald-600 font-medium">{{ jobs.finalizedDeliveryDate }}</span>
                            </div>
                            } @else {
                            <span>{{ jobs.deliveryDate }}</span>
                            }
                            }
                            }
                        </td>
                        <td class="px-4 py-2 text-sm"><span>{{ jobs.dispatchQuantity | number }}</span></td>
                        <td class="px-4 py-2">
                            <div class="flex flex-wrap gap-2">
                                <ng-container *ngFor="let operation of getSortedOperations(jobs.operations)">
                                    <div *ngFor="let machine of operation.machines"
                                        (click)="onOperationOpenModal(operation.jobOperationId)"
                                        class="flex flex-col min-w-[160px] rounded-md overflow-hidden shadow-sm hover:shadow transition-all cursor-pointer border"
                                        [ngClass]="{
                                                    'border-emerald-300': operation.operationStatus === 'completed',
                                                    'border-blue-300': operation.operationStatus === 'in progress' || operation.operationStatus === 'make ready',
                                                    'border-gray-300': operation.operationStatus === 'pending',
                                                    'border-red-300': operation.operationStatus === 'hold',
                                                    'border-red-500 opacity-50 line-through': operation.operationStatus === 'failed' || operation.jobStatus === 'failed'
                                                }">

                                        <div class="px-2 py-1 text-white text-xs font-semibold" [ngClass]="{
                                                        'bg-emerald-500': operation.operationStatus === 'completed',
                                                        'bg-sky-600': operation.operationStatus === 'in progress' || operation.operationStatus === 'make ready',
                                                        'bg-gray-500': operation.operationStatus === 'pending',
                                                        'bg-red-600': operation.operationStatus === 'hold',
                                                        'bg-red-800': operation.operationStatus === 'failed' || operation.jobStatus === 'failed'
                                                    }">
                                            <div class="flex justify-between items-center">

                                                <div class="font-bold">
                                                    {{ operation.stage }} {{ operation.jobPassNumber }}
                                                </div>
                                                <div *ngIf="operation.isResorting === 1 || operation.isReprint === 1 ||operation.isRework === 1"
                                                    class="ml-2 bg-yellow-500 text-white text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
                                                    Re-{{ operation.stage }}
                                                </div>
                                            </div>
                                            <div class="flex justify-between items-center">
                                                <div class="opacity-90">{{ machine.machineName }}</div>
                                                <div *ngIf="operation.jobPassNumber > 1"
                                                    class="ml-2 bg-yellow-500 text-white text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
                                                    {{ operation.jobPassNumber }} Pass
                                                </div>
                                            </div>

                                        </div>

                                        <div class="px-2 py-1.5 bg-white text-xs space-y-1">
                                            <div class="flex justify-between">
                                                <span class="text-gray-600">Planned:</span>
                                                <span class="font-semibold text-gray-900">{{ operation.operationQuantity
                                                    | number}} {{ operation.unit }}</span>
                                            </div>
                                            <div class="flex justify-between">
                                                <span class="text-gray-600">Output:</span>
                                                <span class="font-semibold text-emerald-600">{{ operation.noOfSheets |
                                                    number }} {{ operation.unit }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </td>

                        <td class="px-6 py-4">
                            <div class="flex items-center gap-3">
                                <!-- View job card details -->
                                <button type="button" (click)="onOpenModal(jobs.jobId)" title="View Job Card"
                                    class="text-blue-600 hover:text-emerald-800 transition-colors">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path
                                            d="M11 14H10V10H9M10 6H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </button>

                                <!-- Add Operation Separately -->
                                @if (jobs.jobStatus.toLowerCase() !== 'pending' && showOperationChange()) {
                                <button type="button" (click)="onOpenAddOperation(jobs.jobId)"
                                    title="Add Operation / Shortage / Call Off"
                                    class="text-blue-600 hover:text-blue-800 transition-colors">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2" />
                                    </svg>
                                </button>
                                }
                            </div>
                        </td>

                    </tr>

                    } @empty {
                    <tr>
                        <td colspan="12" class="px-6 py-10">
                            <div class="flex flex-col items-center justify-center text-center">
                                @if (!hasSearched()) {
                                <p class="text-xl font-semibold text-gray-700 mb-2">Search Job Number</p>
                                <p class="text-gray-500">Please enter a job number and search to get data.</p>
                                } @else {
                                <p class="text-xl font-semibold text-gray-700 mb-2">No Jobs Found</p>
                                <p class="text-gray-500">We couldn't find any shipments that match your search criteria.
                                </p>
                                }
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <app-pagination [totalItems]="$$totalItems()" [itemsPerPage]="$$itemsPerPage()"
            (pageChanged)="onPageChange($event)"></app-pagination>
    </div>
</div>


@if (modal.$$openModal()) {
<div id="crud-modal" tabindex="-1" aria-hidden="true"
    class=" fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div class="relative p-4 w-full max-w-7xl mx-auto bg-white rounded-lg shadow-lg">
        <div class="relative">
            <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Job Card Operations</span>
                    <span class="status-badge ml-4"></span>
                </h3>

                <button type="button" (click)="closeModel()"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <div class="pt-4  overflow-y-auto max-h-[700px]">
                <div class="mb-6 p-6 bg-gray-50 shadow rounded-lg">
                    <div class="grid grid-cols-2 gap-4">
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Job Number</span>
                            <span class="text-gray-700 ">{{ jobCardGetDTOS()[0].jobNumber }}</span>
                        </div>
                        <div class="flex items-start text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Customer:</span>
                            <span class="text-gray-700 w-full w-1/2">{{ jobCardGetDTOS()[0].customer }}</span>
                        </div>
                        <div class="flex items-start text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Job Description:</span>
                            <span class="text-gray-700 w-1/2">{{ jobCardGetDTOS()[0].jobDescription }}</span>
                        </div>
                        <div class="flex items-start text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Finishings:</span>
                            <span class="text-gray-700 w-1/2">{{ 'PRINTING, ' + jobCardGetDTOS()[0].finishing }}</span>
                        </div>
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Job Quantity:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].jobQuantity | number }}</span>
                        </div>
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Product Type:</span>
                            <span class="text-gray-700 uppercase">{{ jobCardGetDTOS()[0].productType }}</span>
                        </div>
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Cut Sheets:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].cutSheets }}</span>
                        </div>
                        <div *ngIf="!jobCardGetDTOS()[0].productType || !jobCardGetDTOS()[0].productType.toLowerCase().includes('flexo')"
                            class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">No of Impressions:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].numberOfImpressions | number }}</span>
                        </div>
                        <div *ngIf="!jobCardGetDTOS()[0].productType || !jobCardGetDTOS()[0].productType.toLowerCase().includes('flexo')"
                            class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">No of Cuts:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].numberOfCuts }}</span>
                        </div>
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">No of Ups:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].numberOfUps }}</span>
                        </div>
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">No of Colors:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].numberOfColors }}</span>
                        </div>
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">No of Breakdowns:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].numberOfBreakdowns }}</span>
                        </div>
                        <div class="flex items-center text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Customer Request Date:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].requestDate }}</span>
                        </div>
                        <div class="flex items-start text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Job Status:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].jobStatus }}</span>
                        </div>
                        <div *ngIf="jobCardGetDTOS()[0].productType && jobCardGetDTOS()[0].productType.toLowerCase().includes('flexo')"
                            class="flex items-start text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Reel Length:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].reelLength }}</span>
                        </div>
                        <div *ngIf="jobCardGetDTOS()[0].productType && jobCardGetDTOS()[0].productType.toLowerCase().includes('flexo')"
                            class="flex items-start text-sm">
                            <span class="font-semibold text-gray-600 w-1/2">Reel Width:</span>
                            <span class="text-gray-700">{{ jobCardGetDTOS()[0].reelWidth }}</span>
                        </div>
                    </div>


                    <div *ngIf="showOperationChange()" class="flex items-start mb-2 mt-4 text-sm">
                        <span class="font-semibold text-gray-600 w-1/4">Change Job Status:</span>

                        <select
                            class="focus:ring-gray-100 focus:border-gray-300 block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                            [(ngModel)]="selectedStatus" (change)="checkStatusChange()">
                            <option *ngFor="let status of jobStatuses" [value]="status">
                                {{ status | titlecase }}
                            </option>
                        </select>

                        <button class="button-blue ml-4" [disabled]="!statusChanged" (click)="updateStatus()">
                            Change Status
                        </button>
                    </div>


                </div>


                <div class="max-h-64 overflow-y-auto border rounded-md">
                    <table class="table">
                        <thead class="table-thead">
                            <tr>
                                <th scope="col" class="px-6 py-3">Sequence</th>
                                <th scope="col" class="px-6 py-3">Operation Status</th>
                                <th scope="col" class="px-6 py-3">Estimated date</th>
                                <th scope="col" class="px-6 py-3">Start Date</th>
                                <th scope="col" class="px-6 py-3">Completed Date</th>
                                <th scope="col" class="px-6 py-3">Message</th>
                                <th scope="col" class="px-6 py-3">Planned</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (jobs of jobCardGetDTOS(); track jobs.id){
                            @for(op of jobs.jobOperations; track op){
                            <tr class="bg-white border-b">
                                <td class="px-6 py-2 text-sm">{{ op.stage }}
                                <td class="px-6 py-2 text-sm"><app-status-badge
                                        [jobStatus]="op.jobStatus"></app-status-badge></td>
                                <td class="px-6 py-2 text-sm">{{ op.estimatedDateTime | date:'yyyy-MM-dd'}}
                                <td class="px-6 py-2 text-sm">{{ op.startDateTime | date:'yyyy-MM-dd HH:MM'}}
                                <td class="px-6 py-2 text-sm">{{ op.completeDateTime | date:'yyyy-MM-dd HH:MM' }}
                                <td class="px-6 py-2 text-sm">{{ getCompletedMessege(op.estimatedDateTime,
                                    op.completeDateTime) }}
                                <td class="px-6 py-2 text-sm">{{ op.operationQuantity }}
                            </tr>
                            }
                            } @empty {
                            <tr>
                                <td colspan="12" class="px-6 py-10">
                                    <div class="flex flex-col items-center justify-center text-center">
                                        <p class="text-xl font-semibold text-gray-700 mb-2">No Hold Jobs</p>
                                        <p class="text-gray-500">We couldn't find any paused jobs</p>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
}

@if(modal.$$openOpeartion()){
<div id="operation-modal" tabindex="-1" aria-hidden="true"
    class=" fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div class="relative p-4 w-full max-w-5xl mx-auto bg-white rounded-lg shadow-lg">
        <div class="relative">
            <div class="flex items-center justify-between p-4 border-b rounded-t">
                <div class="flex flex-col">
                    <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                        <span>Job Operation Details - {{ GetJobOperationDTO()[0].workOrderId }}</span>
                        <span class="status-badge ml-4"></span>
                    </h3>

                    <p class="text-sm text-gray-500 mt-1">
                        {{ GetJobOperationDTO()[0].workOrderName }}
                    </p>
                </div>
                <button type="button" (click)="modal.$$openOpeartion.set(false)"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <div class="pt-4">
                <div class="mb-4 p-6 bg-gray-50 rounded-lg border">
                    <div class="grid grid-cols-2 gap-4">
                        <div class="flex items-center ">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Machine Name</span>
                            <span class="text-gray-700 text-sm">{{ GetJobOperationDTO()[0].machine_details.machineName
                                }}</span>
                        </div>
                        <div class="flex items-center ">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Estimate Date and Time</span>
                            <span class="text-gray-700 text-sm">{{ GetJobOperationDTO()[0].estimatedDateTime |
                                date:'yyyy-MM-dd HH:mm:ss' }}</span>
                        </div>
                        <div class="flex items-center ">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Start Date</span>
                            <span class="text-gray-700 text-sm">{{ GetJobOperationDTO()[0].startedDateTime | date:
                                'yyyy-MM-dd HH:mm:ss' }}</span>
                        </div>
                        <div class="flex items-center ">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Completed Date and Time</span>
                            <span class="text-gray-700 text-sm">{{ GetJobOperationDTO()[0].completedDateTime |
                                date:'yyyy-MM-dd HH:mm:ss' }}</span>
                        </div>
                        <div class="flex items-center ">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Operation Status</span>
                            <span class="text-gray-700 text-sm">{{ GetJobOperationDTO()[0].jobStatus | uppercase
                                }}</span>
                        </div>
                        <div class="flex items-center">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Duration</span>
                            <span class="text-gray-700 text-sm">
                                {{ getDuration(GetJobOperationDTO()[0].startedDateTime,
                                GetJobOperationDTO()[0].completedDateTime) }}
                            </span>
                        </div>
                        <div *ngIf="GetJobOperationDTO()[0].isResorting === 1" class="flex items-center">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Re-{{ GetJobOperationDTO()[0].stage
                                }}</span>
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase
                                bg-yellow-100 text-yellow-800">
                                Yes
                            </span>
                        </div>
                        <div class="flex items-center">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Remarks</span>
                            <span class="text-gray-700 text-sm">
                                {{ GetJobOperationDTO()[0].remarks }}
                            </span>
                        </div>

                        <!-- Is Final Operation -->
                        <div class="flex items-center">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Is Final Operation</span>
                            <div class="flex items-center gap-2">
                                <input type="checkbox" id="opDetailIsFinal" [checked]="GetJobOperationDTO()[0].isFinal"
                                    (change)="updateIsFinal($event, GetJobOperationDTO()[0])"
                                    [disabled]="isUpdatingIsFinal()"
                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 cursor-pointer disabled:opacity-50">
                                <label for="opDetailIsFinal" class="text-sm font-medium cursor-pointer"
                                    [class.text-blue-700]="GetJobOperationDTO()[0].isFinal"
                                    [class.text-gray-600]="!GetJobOperationDTO()[0].isFinal">
                                    {{ GetJobOperationDTO()[0].isFinal ? 'Yes' : 'No' }}
                                </label>
                                @if (isUpdatingIsFinal()) {
                                <span class="text-xs text-blue-500 italic">Updating...</span>
                                }
                            </div>
                        </div>

                        <!-- Reprint Reason -->
                        @if (GetJobOperationDTO()[0].reprint_reason) {
                        <div class="flex items-center">
                            <span class="font-semibold text-sm text-gray-600 w-1/2">Reprint Reason</span>
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase
                                bg-amber-100 text-amber-800">
                                {{ GetJobOperationDTO()[0].reprint_reason.reason }}
                            </span>
                        </div>
                        }
                    </div>

                    <!-- NCR Operators (full-width, only when present) -->
                    @if (GetJobOperationDTO()[0].ncrOperators.length > 0) {
                    <div class="mt-4 pt-4 border-t">
                        <div class="flex items-center gap-2 mb-3">
                            <svg class="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            <span class="text-xs font-bold text-gray-500 uppercase">NCR Operators</span>
                        </div>
                        <div class="flex flex-wrap gap-2">
                            @for (op of GetJobOperationDTO()[0].ncrOperators; track op.id) {
                            <span
                                class="inline-flex items-center gap-2 bg-white border border-gray-200 shadow-sm text-gray-800 text-xs font-medium px-3 py-1.5 rounded-full">
                                <span class="font-semibold">{{ op.name | titlecase }}</span>
                                <span class="text-gray-300">&middot;</span>
                                <span class="text-gray-500 italic">{{ op.ncrReason }}</span>
                                @if (op.ncrNumber) {
                                <span class="text-gray-400 font-medium">({{ op.ncrNumber }})</span>
                                }
                                <span class="text-gray-400 text-xs">({{ op.empNo }})</span>
                            </span>
                            }
                        </div>
                    </div>
                    }
                </div>


                <div class="mb-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-lg shadow-sm">
                    <div class="max-h-48 overflow-y-auto pr-2">
                        <table class="w-full text-sm relative">
                            <thead class="sticky top-0 bg-blue-50 z-10">
                                <tr class="border-b border-blue-100 text-left text-blue-700">
                                    <th class="px-4 py-2 font-medium">Operator</th>
                                    <th class="px-4 py-2 font-medium">Shift</th>
                                    <th class="px-4 py-2 font-medium">Date</th>
                                    <th class="px-4 py-2 font-medium text-right">Output</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (op of operatorSummary(); track op.operatorId) {
                                <tr class="border-b border-blue-50 hover:bg-white/60 transition">

                                    <td class="px-4 py-2 text-sm text-gray-600 font-semibold">
                                        {{ op.operatorName }}
                                    </td>

                                    <td>
                                        <span
                                            class="px-4 py-1 text-xs font-semibold rounded-full bg-blue-200 text-blue-700">
                                            {{ op.shiftName }}
                                        </span>
                                    </td>

                                    <td>
                                        <span
                                            class="px-2 py-1 text-xs font-semibold rounded-full bg-blue-200 text-blue-700">
                                            {{ op.actualDate | date:'yyyy-MM-dd' }}
                                        </span>
                                    </td>

                                    <td class="px-4 py-2 text-right font-semibold text-blue-700">
                                        {{ op.output }}
                                    </td>

                                </tr>
                                } @empty {
                                <tr>
                                    <td colspan="4" class="px-4 py-6 text-center text-gray-500">
                                        No operator data available
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="max-h-64 overflow-y-auto border rounded-md">

                    <table class="table w-full">
                        <thead class="table-thead sticky top-0 bg-white z-10">
                            <tr>
                                <th scope="col" class="px-6 py-3">Paused At</th>
                                <th scope="col" class="px-6 py-3">Resume At</th>
                                <th scope="col" class="px-6 py-3">Reason</th>
                            </tr>
                        </thead>

                        <tbody>
                            @if (rescheduledHoldReason()) {
                            <tr class="bg-white border-b">
                                <td class="px-6 py-2 text-sm">
                                    {{ rescheduledHoldReason()?.pausedAt | date: 'yyyy-MM-dd HH:mm:ss' }}
                                </td>
                                <td class="px-6 py-2 text-sm">
                                    {{ rescheduledHoldReason()?.resumedAt ? (rescheduledHoldReason()?.resumedAt | date:
                                    'yyyy-MM-dd HH:mm:ss') : '-' }}
                                </td>
                                <td class="px-6 py-2 text-sm">
                                    {{ rescheduledHoldReason()?.holdReason }}
                                </td>
                            </tr>
                            }
                            @for (op of GetJobOperationDTO(); track op) {
                            @for (time of op.operation_time; track time.id) {
                            @if (time.reason && time.reason.toLowerCase() !== 'operational') {
                            <tr class="bg-white border-b">
                                <td class="px-6 py-2 text-sm">
                                    {{ time.pausedAt | date: 'yyyy-MM-dd HH:mm:ss' }}
                                </td>
                                <td class="px-6 py-2 text-sm">
                                    {{ time.resumedAt | date: 'yyyy-MM-dd HH:mm:ss' }}
                                </td>
                                <td class="px-6 py-2 text-sm">
                                    {{ time.reason }}
                                </td>
                            </tr>
                            }
                            }
                            } @empty {
                            <tr>
                                <td colspan="3" class="px-6 py-10">
                                    <div class="flex flex-col items-center justify-center text-center">
                                        <p class="text-xl font-semibold text-gray-700 mb-2">
                                            No Hold Jobs
                                        </p>
                                        <p class="text-gray-500">
                                            We couldn't find any paused jobs
                                        </p>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>

                </div>

            </div>

        </div>
    </div>
</div>
}

<!-- @if (modal.$$MachineSelector()){
    <app-device-select></app-device-select>
} -->

@if (modal.$$reportDownload()) {
<div id="operation-modal" tabindex="-1" aria-hidden="true"
    class=" fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div class="relative p-4 mx-auto bg-white rounded-lg shadow-lg">
        <div class="relative">
            <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Delivery Plannig Report Download</span>
                    <span class="status-badge ml-4"></span>
                </h3>
                <button type="button" (click)="closeReportDownload()"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <div class="pt-4 px-4">
                <div class="grid grid-cols-2 gap-3">
                    <div class="flex flex-col">
                        <label class="text-sm text-gray-600 mb-1 font-semibold">Start Date</label>
                        <input type="date" class="textField" [(ngModel)]="searchParamsDelivery().start_date"
                            (change)="onStartDateChange()" />
                    </div>

                    <div class="flex flex-col">
                        <label class="text-sm text-gray-600 mb-1 font-semibold">End Date</label>
                        <input type="date" class="textField" [(ngModel)]="searchParamsDelivery().end_date"
                            [min]="minEndDate" />
                    </div>
                </div>

                <div class="pt-4 pb-2 flex justify-end">
                    <button class="button-blue" (click)="downloadDeliveryReportCSV()">
                        Download Report
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
}

<!-- ============================================================
     Add Operations Separately / Shortage or Call Off Modal
     Opened via the blue + icon in the Action column
============================================================ -->
@if (modal.$$openAddOperation()) {
<div id="add-operation-modal" tabindex="-1" aria-hidden="true"
    class="fixed inset-0 z-50 flex justify-center items-center bg-gray-900 bg-opacity-50 p-4">
    <div class="relative w-full max-w-4xl bg-white rounded-lg shadow-2xl flex flex-col max-h-[90vh]">

        <!-- ── Header ── -->
        <div class="flex items-start justify-between px-6 py-4 border-b shrink-0">
            <div>
                <h3 class="text-lg font-bold text-gray-900">Add Operation / Shortage / Call Off</h3>
                @if (jobCardGetDTOS().length > 0) {
                <p class="text-xs text-gray-500 mt-0.5 uppercase tracking-wide">
                    {{ jobCardGetDTOS()[0].jobNumber }} &mdash; {{ jobCardGetDTOS()[0].jobDescription }}
                </p>
                }
            </div>
            <button type="button" (click)="closeAddOperation()"
                class="text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg w-8 h-8 flex items-center justify-center transition-colors ml-4 shrink-0">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
            </button>
        </div>

        <!-- ── Scrollable Body ── -->
        <div class="overflow-y-auto flex-1 px-6 py-5 space-y-5">
            @if (jobCardGetDTOS().length > 0) {

            <!-- ── Section: Operational Info ── -->
            <div>
                <div class="flex items-center gap-2 mb-3">
                    <span class="text-xs font-bold text-gray-500 uppercase">Operational Info</span>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <!-- Finishings -->
                    <div class="flex flex-col">
                        <label class="text-xs font-bold text-gray-500 mb-1.5">Finishings</label>
                        <select class="textField" [(ngModel)]="selectedFinishingValue"
                            (ngModelChange)="onFinishingChange($event)" name="selectedStage">
                            <option value="" hidden disabled>Choose A Stage</option>
                            @if (!hasBreakingInWorkOrders()) {
                            <option value="BREAKING">BREAKING</option>
                            }
                            @for (wo of jobCardGetDTOS()[0].workOrders; track wo.id) {
                            <option [value]="wo.workOrderId ? (wo.operation + ':::' + wo.workOrderId) : wo.operation">
                                {{ wo.operation | uppercase }}{{ wo.workOrderId ? ' - ' + wo.workOrderId : '' }}
                            </option>
                            }
                        </select>
                    </div>
                    <!-- Department -->
                    <!-- <div class="flex flex-col">
                        <label class="text-xs font-bold text-gray-500 mb-1.5">Department</label>
                        <select class="textField" [ngModel]="departmentId()"
                            (ngModelChange)="onDepartmentChange($event)" name="addOpDept">
                            <option [ngValue]="null" hidden disabled selected>Choose a Department</option>
                            @for (dept of $$departmentDTO(); track dept.departmentId) {
                            <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
                            }
                        </select>
                    </div> -->
                    <!-- Machine -->
                    <div class="flex flex-col">
                        <label class="text-xs font-bold text-gray-500 mb-1.5">Machine</label>
                        <select class="textField" [(ngModel)]="machineId" (ngModelChange)="onMachineSelect($event)"
                            name="addOpMachine">
                            <option [ngValue]="null" hidden disabled selected>Choose a Machine</option>
                            @for (machine of availableMachines; track machine) {
                            <option [ngValue]="machine.machineId">{{ machine.machineName | titlecase }}</option>
                            }
                        </select>
                    </div>
                </div>
            </div>

            <!-- ── Section: Schedule + Production Details ── -->
            <div class="grid grid-cols-2 gap-4">
                <!-- Schedule -->
                <div class="border rounded-lg p-4">
                    <div class="flex items-center gap-2 mb-3">
                        <span class="text-xs font-bold text-gray-500 uppercase">Schedule</span>
                    </div>
                    <div class="grid grid-cols-2 gap-3">
                        <div class="flex flex-col">
                            <label class="text-xs font-bold text-gray-500  mb-1.5">Estimate Date</label>
                            <input type="datetime-local" [min]="minDate" class="textField" [(ngModel)]="estimateDate"
                                name="addOpEstDate" />
                        </div>
                        <div class="flex flex-col">
                            <label class="text-xs font-bold text-gray-500 mb-1.5">Estimate Time (Hrs)</label>
                            <input type="number" min="0" step="0.01" class="textField" [(ngModel)]="estimateTime"
                                placeholder="Hours" name="addOpEstTime" />
                        </div>
                    </div>
                </div>

                <!-- Production Details -->
                <div class="border rounded-lg p-4">

                    <div class="flex items-center gap-2 mb-3">
                        <span class="text-xs font-bold text-gray-500 uppercase">Production Details</span>
                    </div>
                    <div class="grid grid-cols-2 gap-3">
                        <div class="flex flex-col">
                            <label class="text-xs font-bold text-gray-500 mb-1.5">Planned Qty</label>
                            <input type="number" min="0" class="textField" [(ngModel)]="opQuantity"
                                placeholder="Quantity" name="addOpQty" />
                        </div>
                        <div class="flex flex-col">
                            <label class="text-xs font-bold text-gray-500 mb-1.5">Pass Count</label>
                            <select class="textField" [(ngModel)]="passCount" name="addOpPass">
                                <option [ngValue]="1">1</option>
                                <option [ngValue]="2">2</option>
                                <option [ngValue]="3">3</option>
                                <option [ngValue]="4">4</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Inline row: Is Resorting / Is Reprint / Reprint Reason / Remarks ── -->
            <div class="flex flex-wrap items-end gap-4">

                <!-- Is Re-[Stage] checkbox — shown for any selected stage -->
                @if (selectedStage) {
                <div class="flex items-center gap-2 pb-2">
                    <input type="checkbox" [(ngModel)]="isRework" id="addOpIsRework" name="addOpIsRework"
                        (ngModelChange)="reprintReason = ''; ncrOperatorPickId = null; ncrOperatorPickReason = ''; ncrOperators = []"
                        class="w-4 h-4 text-blue-600 border-gray-300 rounded accent-blue-600">
                    <label for="addOpIsRework" class="text-sm font-semibold text-gray-700">Is Re-{{ selectedStage
                        }}</label>
                </div>

                <!-- Is Final checkbox -->
                <div class="flex items-center gap-2 pb-2">
                    <input type="checkbox" [(ngModel)]="isFinal" id="addOpIsFinal" name="addOpIsFinal"
                        class="w-4 h-4 text-blue-600 border-gray-300 rounded accent-blue-600">
                    <label for="addOpIsFinal" class="text-sm font-semibold text-gray-700">Is Final</label>
                </div>

                <!-- Rework Reason — shown when isRework is checked -->
                @if (isRework && selectedStage == 'PRINTING') {
                <div class="flex flex-col flex-1 min-w-[160px]">
                    <label class="text-xs font-bold text-gray-500 mb-1.5">Re-{{ selectedStage }} Reason</label>
                    <select class="textField" [(ngModel)]="reprintReason"
                        (ngModelChange)="ncrOperatorPickId = null; ncrOperatorPickReason = ''; ncrOperators = []"
                        name="addOpReworkReason">
                        <option value="" disabled hidden>Select Reason</option>
                        @for (reason of reprintReasons; track reason) {
                        <option [value]="reason">{{ reason }}</option>
                        }
                    </select>
                </div>
                }
                }

                <!-- Remarks (always visible, grows to fill space) -->
                <div class="flex flex-col flex-1 min-w-[200px]">
                    <label class="text-xs font-bold text-gray-500 mb-1.5">Remarks</label>
                    <input type="text" class="textField" [(ngModel)]="remarks" placeholder="Remarks"
                        name="addOpRemarks" />
                </div>
            </div>

            <!-- ── NCR Operators panel (full width, conditional) ── -->
            @if (isRework && reprintReason === 'ncr') {
            <div class="border border-gray-200 rounded-lg bg-gray-50 p-4">
                <div class="flex items-center gap-2 mb-3">
                    <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span class="text-xs font-bold text-gray-500 uppercase">NCR Operators</span>
                </div>

                <!-- Picker row -->
                <div class="flex gap-2 flex-wrap items-center">
                    <select class="textField flex-1 min-w-[160px]" [(ngModel)]="ncrOperatorPickId" name="addOpNcrOpId">
                        <option [ngValue]="null" disabled hidden>Select Operator</option>
                        @for (op of $$operators(); track op.operatorId) {
                        <option [ngValue]="op.operatorId">{{ op.operatorName | titlecase }}</option>
                        }
                    </select>

                    <input type="text" class="textField flex-1 min-w-[200px]" [(ngModel)]="ncrOperatorPickReason"
                        name="addOpNcrReason" placeholder="NCR reason (e.g. ink issue)" />

                    <input type="text" class="textField flex-1 min-w-[150px]" [(ngModel)]="ncrOperatorPickNumber"
                        name="addOpNcrNumber" placeholder="NCR Number (e.g. NCR-123)" />

                    <button type="button"
                        class="inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors whitespace-nowrap"
                        (click)="addNcrOperator()">
                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                        </svg>
                        Add
                    </button>
                </div>

                <!-- Chips -->
                @if (ncrOperators.length > 0) {
                <div class="flex flex-wrap gap-2 mt-3">
                    @for (entry of ncrOperators; track entry.operatorId) {
                    <span
                        class="inline-flex items-center gap-1.5 bg-white border border-gray-300 text-gray-800 text-xs font-medium px-3 py-1.5 rounded-full shadow-sm">
                        <span class="font-semibold">{{ getNcrOperatorName(entry.operatorId) | titlecase }}</span>
                        <span class="text-gray-400">&middot;</span>
                        <span class="text-gray-500 italic">{{ entry.ncrReason }}</span>
                        @if (entry.ncrNumber) {
                        <span class="text-gray-400 font-medium">({{ entry.ncrNumber }})</span>
                        }
                        <button type="button" (click)="removeNcrOperator(entry.operatorId)"
                            class="ml-0.5 text-gray-400 hover:text-red-500 font-bold text-sm leading-none transition-colors">
                            &times;
                        </button>
                    </span>
                    }
                </div>
                }
            </div>
            }

            }<!-- end jobCardGetDTOS guard -->
        </div>

        <!-- ── Sticky Footer ── -->
        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t bg-white rounded-b-xl shrink-0">
            <button type="button" (click)="closeAddOperation()"
                class="px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                Cancel
            </button>
            <button type="button" (click)="saveMachineDetails()"
                class="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                </svg>
                Save Operation
            </button>
        </div>

    </div>
</div>
}